import script from "./MappingColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./MappingColumn.vue?vue&type=script&setup=true&lang=js"

import "./MappingColumn.vue?vue&type=style&index=0&id=001b82ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001b82ba"]])

export default __exports__